import { ApiVersion } from 'models/ApiVersion';
import { createReducer } from 'store/createReducer';
import {
  ProductPageReviewSummarySet,
  PRODUCT_PAGE_REVIEW_SUMMARY_SET,
  ProductPageRedReviewsSet,
  PRODUCT_PAGE_RED_REVIEWS_SET
} from './actions';
import { RedReviews } from 'models/RedReviews';
import { RatingPerLevel } from 'models/RatingPerLevel';
import { RedReview } from 'models/RedReview';

const ratingsPerLevel = createReducer<RatingPerLevel[]>([], {
  [PRODUCT_PAGE_REVIEW_SUMMARY_SET]: (state, action: ProductPageReviewSummarySet) =>
    action.data.ratingsPerLevel ? action.data.ratingsPerLevel : state
});

const mostPopularReview = createReducer<RedReview>(
  {
    author: '',
    comment: '',
    productKey: '',
    reviewId: '',
    productId: '',
    helpful: 0,
    notHelpful: 0,
    score: 0,
    cons: [],
    pros: [],
    images: [],
    date: new Date(),
    verifiedBuyer: false,
    hasVoted: false,
    response: undefined,
    version: ApiVersion.RD3
  },
  {
    [PRODUCT_PAGE_REVIEW_SUMMARY_SET]: (state, action: ProductPageReviewSummarySet) =>
      action.data.review || state
  }
);

const redReviews = createReducer<RedReviews>(
  { reviews: [], pageNumber: 1 },
  {
    [PRODUCT_PAGE_RED_REVIEWS_SET]: (state, action: ProductPageRedReviewsSet) =>
      action.reviews || state
  }
);

export const reviewReducers = {
  redReviews,
  ratingsPerLevel,
  mostPopularReview
};
